import * as React from "react";
const SvgSeachIconConvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2em"
    height="2em"
    fill="none"
    viewBox="0 0 29 30"
    {...props}
  >
    <path
      fill="#595959"
      d="m25.518 25.28-5.476-5.475a9.637 9.637 0 1 0-1.237 1.237l5.475 5.476a.876.876 0 1 0 1.238-1.238M4.774 13.65a7.875 7.875 0 1 1 7.875 7.874 7.884 7.884 0 0 1-7.875-7.875"
    />
  </svg>
);
export default SvgSeachIconConvg;
